import { Address } from '@vfde-sails/avc-core';
import { AppError } from '../App/interface';
import {
    AvcAction,
    Inputs,
} from './enum';

/**
 * Checks if seamless availability check is needed and inits it
 */
export const checkSeamlessAvailability = (forceSeamless = false) => ({
    type: AvcAction.CHECK_SEAMLESS_AVAILABILITY,
    forceSeamless,
} as const);

/**
 * Sets error state of avc
 */
export const setError = (error?: AppError) => ({
    type: AvcAction.SET_ERROR,
    error,
} as const);

/**
 * Sets selected address
 */
export const setSelectedAddress = (index: string | number, address?: Address) => ({
    type: AvcAction.SET_SELECTED_ADDRESS,
    index: +index,
    address,
} as const);

/**
 * Sets input of avc form
 */
export const setInput = (name: Inputs, value: string) => ({
    type: AvcAction.SET_INPUT,
    name,
    value,
} as const);

/**
 * Sets valid addresses
 */
export const setAddresses = (addresses: Address[]) => ({
    type: AvcAction.SET_ADDRESSES,
    addresses,
} as const);

/**
 * Inits address check
 */
export const checkAddress = () => ({
    type: AvcAction.CHECK_ADDRESS,
} as const);

/**
 * Resets form
 */
export const resetForm = () => ({
    type: AvcAction.RESET_FORM,
} as const);

/**
 * AVC Actions
 */
export type Actions = ReturnType<typeof setError>
    | ReturnType<typeof setInput>
    | ReturnType<typeof setSelectedAddress>
    | ReturnType<typeof setAddresses>
    | ReturnType<typeof checkAddress>
    | ReturnType<typeof checkSeamlessAvailability>
    | ReturnType<typeof resetForm>;
